import { AdministrationAccountEP } from './AdministrationAccountEP';
import { AppCustomDataEP } from './AppCustomDataEP'
import { BookingsEP } from './BookingsEP';
import { ConfigurationEP } from './ConfigurationEP';
import { ErrorNotificationsEP } from './ErrorNotificationsEP';
import { HotelsEP } from './HotelsEP';
import { LanguagesEP } from './LanguagesEP';
import { NewsEP } from './NewsEP';
import { RegimesEP } from './RegimesEP';
import { RoomsEP } from './RoomsEP';
import { ServicesEP } from './ServicesEP';
import { UsersEP } from './UsersEP';
import { ContractsEP } from './ContractsEP';
import { CommissionConfigurationEP } from './CommissionConfigurationEP';
import { CountriesEP } from './CountriesEP';
import { PaymentsConfigurationEP } from './PaymentsConfigurationEP';
import { StaticDataEP } from './StaticDataEP';
import { TPVEP } from './TPVEP';

export const RegisterEndPoints = []
    .concat(AdministrationAccountEP)
    .concat(AppCustomDataEP)
    .concat(BookingsEP)
    .concat(ConfigurationEP)
    .concat(ErrorNotificationsEP)
    .concat(HotelsEP)
    .concat(LanguagesEP)
    .concat(RegimesEP)
    .concat(RoomsEP)
    .concat(ServicesEP)
    .concat(UsersEP)
    .concat(ContractsEP)
    .concat(NewsEP)
    .concat(CommissionConfigurationEP)
    .concat(CountriesEP)
    .concat(PaymentsConfigurationEP)
    .concat(StaticDataEP)
    .concat(TPVEP)
    ;
